import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center text-xl"
}
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = {
  key: 0,
  class: "text-center text-xl"
}
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = { class: "detail-info-row" }
const _hoisted_7 = { class: "detail-info-pair" }
const _hoisted_8 = { class: "detail-info-pair__label" }
const _hoisted_9 = { class: "detail-info-pair__value" }
const _hoisted_10 = { class: "detail-info-pair" }
const _hoisted_11 = { class: "detail-info-pair__label" }
const _hoisted_12 = { class: "detail-info-pair__value" }
const _hoisted_13 = { class: "detail-info-row" }
const _hoisted_14 = { class: "detail-info-pair" }
const _hoisted_15 = { class: "detail-info-pair__label" }
const _hoisted_16 = { class: "detail-info-pair__value" }
const _hoisted_17 = { class: "detail-info-pair" }
const _hoisted_18 = { class: "detail-info-pair__label" }
const _hoisted_19 = { class: "detail-info-pair__value" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "detail-info-row" }
const _hoisted_22 = { class: "detail-info-pair" }
const _hoisted_23 = { class: "detail-info-pair__label" }
const _hoisted_24 = { class: "detail-info-pair__value" }
const _hoisted_25 = { class: "detail-info-pair" }
const _hoisted_26 = { class: "detail-info-pair__label" }
const _hoisted_27 = { class: "detail-info-pair__value" }
const _hoisted_28 = { class: "detail-info-row detail-info-row--single" }
const _hoisted_29 = { class: "detail-info-pair" }
const _hoisted_30 = { class: "detail-info-pair__label" }
const _hoisted_31 = { class: "detail-info-pair__value" }
const _hoisted_32 = {
  key: 0,
  class: "detail-info-row detail-info-row--single"
}
const _hoisted_33 = { class: "detail-info-pair" }
const _hoisted_34 = { class: "detail-info-pair__label" }
const _hoisted_35 = { class: "detail-info-pair__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddVatTuItemV2 = _resolveComponent("AddVatTuItemV2")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PageHeaderActionItem = _resolveComponent("PageHeaderActionItem")!
  const _component_Can = _resolveComponent("Can")!
  const _component_PageHeaderActions = _resolveComponent("PageHeaderActions")!
  const _component_DetailTopicLottie = _resolveComponent("DetailTopicLottie")!
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_DmvtTkGroupped = _resolveComponent("DmvtTkGroupped")!
  const _component_PageContentSection = _resolveComponent("PageContentSection")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_FilterItem = _resolveComponent("FilterItem")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_FilterContainer = _resolveComponent("FilterContainer")!
  const _component_VatTuKhoTable = _resolveComponent("VatTuKhoTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_FilterPhieuNhapXuat = _resolveComponent("FilterPhieuNhapXuat")!
  const _component_PhieuNhapKhoTableV2 = _resolveComponent("PhieuNhapKhoTableV2")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_PhieuXuatKhoTable = _resolveComponent("PhieuXuatKhoTable")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.warehouseDetail)
      ? (_openBlock(), _createBlock(_component_AddVatTuItemV2, {
          key: 0,
          "use-for": _ctx.AddVatTuItemsFor.KHO,
          "is-modal-open": _ctx.isAddVatTuModalDisplay,
          "kho-id": _ctx.warehouseId,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isAddVatTuModalDisplay = false)),
          onAdded: _ctx.onVatTuIntoKhoAdded
        }, null, 8, ["use-for", "is-modal-open", "kho-id", "onAdded"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmationDialog, {
      title: "Xác nhận",
      size: "sm",
      "is-display": _ctx.isDeleteKhoConfirmationDialogDisplay,
      onOnCloseButtonClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDeleteKhoConfirmationDialogDisplay = false)),
      onOnCloseIconClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDeleteKhoConfirmationDialogDisplay = false)),
      onOnConfirmButtonClick: _ctx.confirmDeleteKho
    }, {
      default: _withCtx(() => [
        (_ctx.warehouseDetail)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_1, [
              _createTextVNode(" Bạn hãy chắc chắn muốn xóa kho "),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.warehouseDetail.ten_kho), 1),
              _createTextVNode("? ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-display", "onOnConfirmButtonClick"]),
    _createVNode(_component_ConfirmationDialog, {
      title: "Xác nhận",
      size: "sm",
      "is-display": _ctx.isDeletingModalDisplay,
      onOnCloseButtonClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDeletingModalDisplay = false)),
      onOnCloseIconClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDeletingModalDisplay = false)),
      onOnConfirmButtonClick: _ctx.confirmDelete
    }, {
      default: _withCtx(() => [
        (_ctx.deletingVatTu)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_3, [
              _createTextVNode(" Bạn hãy chắc chắn muốn xóa vật tư "),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.deletingVatTu.ten_vat_tu), 1),
              _createTextVNode(" khỏi kho "),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.warehouseDetail?.ten_kho), 1),
              _createTextVNode("? ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-display", "onOnConfirmButtonClick"]),
    (_ctx.warehouseDetail)
      ? (_openBlock(), _createBlock(_component_PageHeaderActions, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_Can, {
              all: [_ctx.KHO.SUA]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PageHeaderActionItem, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.push(`/quan-ly/kho/${_ctx.warehouseId}/cap-nhat`)))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: _ctx.faPencil }, null, 8, ["icon"])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" Chỉnh sửa ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["all"]),
            _createVNode(_component_Can, {
              all: [_ctx.KHO.XOA]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PageHeaderActionItem, {
                  variant: "danger",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isDeleteKhoConfirmationDialogDisplay = true))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: _ctx.faTrash }, null, 8, ["icon"])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" Xoá kho ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["all"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_PageContentBase, { plain: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_PageContentSection, null, {
          header: _withCtx(() => [
            _createTextVNode("Thông tin")
          ]),
          illustration: _withCtx(() => [
            _createVNode(_component_DetailTopicLottie, { topic: "kho" })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Tên kho: ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.warehouseDetail?.ten_kho), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Địa chỉ: ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.warehouseDetail?.dia_chi), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Mã kho: ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.warehouseDetail?.ma_kho), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ghi chú ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_19, [
                  (_ctx.warehouseDetail)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.warehouseDetail.ghi_chu || ""), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ngày tạo: ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.warehouseDetail?.created_at).format("DD/MM/YYYY")), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cập nhật cuối: ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.warehouseDetail?.updated_at).format("DD/MM/YYYY")), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("TK Nhóm vật tư ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_DmvtTkGroupped, {
                    data: _ctx.warehouseDetail?.dmvt_groupped_tk || [],
                    "empty-message": "Không có dữ liệu",
                    "badge-class": "badge badge-light-primary",
                    "empty-message-class": "text-danger"
                  }, null, 8, ["data"])
                ])
              ])
            ]),
            (_ctx.warehouseDetail?.tk_ketoan?.mact)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode("TK Thẻ kho ")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.warehouseDetail.tk_ketoan.mact), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_PageContentSection, null, {
          header: _withCtx(() => [
            _createTextVNode("Vật tư")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_FilterContainer, null, {
              default: _withCtx(() => [
                _createVNode(_component_FilterItem, { label: "Tìm kiếm vật tư" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.searchTerm,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchTerm) = $event)),
                      placeholder: "Mã hoặc tên",
                      onInput: _ctx.search
                    }, null, 8, ["modelValue", "onInput"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_FilterItem, { label: "Thu hồi" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      modelValue: _ctx.thuHoiFilter,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.thuHoiFilter) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_FilterItem, { label: "C/ty quản lý" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      modelValue: _ctx.congTyDuyetFilter,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.congTyDuyetFilter) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_VatTuKhoTable, {
              vatTuItems: _ctx.vatTuKhoComputed,
              "is-delete-button-display": false,
              onOnDelete: _ctx.onDeleteVatTuButtonClicked
            }, null, 8, ["vatTuItems", "onOnDelete"]),
            (_ctx.vatTuKhoComputed.length > 0)
              ? (_openBlock(), _createBlock(_component_Pagination, {
                  key: 0,
                  page: _ctx.currentPageVatTu,
                  total: _ctx.totalVatTuItems,
                  onChangePage: _cache[10] || (_cache[10] = (value) => (_ctx.currentPageVatTu = value)),
                  onChangePageSize: _cache[11] || (_cache[11] = (value) => (_ctx.perPageVatTu = value))
                }, null, 8, ["page", "total"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_PageContentSection, null, {
          header: _withCtx(() => [
            _createTextVNode("Phiếu nhập kho")
          ]),
          actions: _withCtx(() => [
            _createVNode(_component_Can, {
              all: [_ctx.PHIEU_NHAP_KHO.TAO_MOI]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ButtonCustom, {
                  classes: `rounded-none m-0`,
                  "button-type": _ctx.ButtonsType.SOLID_FILE_IMPORT,
                  onClick: _ctx.goToCreatePhieuTamNhap
                }, {
                  "button-label": _withCtx(() => [
                    _createTextVNode("Nhập khác")
                  ]),
                  _: 1
                }, 8, ["button-type", "onClick"])
              ]),
              _: 1
            }, 8, ["all"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_FilterContainer, null, {
              default: _withCtx(() => [
                _createVNode(_component_FilterItem, { label: "Tìm kiếm phiếu nhập" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.searchTermPhieuNhap,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.searchTermPhieuNhap) = $event)),
                      placeholder: "Tìm theo mã hoặc tên",
                      onInput: _ctx.searchPhieuNhap
                    }, null, 8, ["modelValue", "onInput"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_FilterPhieuNhapXuat, {
                  "loai-phieu": "nhap",
                  onUpdateFilters: _ctx.updateFilterPhieuNhap
                }, null, 8, ["onUpdateFilters"])
              ]),
              _: 1
            }),
            _createVNode(_component_PhieuNhapKhoTableV2, {
              "cur-page": _ctx.currentPagePhieuNhap,
              "id-kho": _ctx.warehouseId,
              items: _ctx.phieuNhapKhoItems,
              "per-page": _ctx.perPagePhieuNhap,
              "show-edit-button": true,
              onOnDetailButtonClick: _ctx.onPhieuNhapDetailButtonClicked,
              onRefresh: _ctx.fetchPhieuNhapItems
            }, null, 8, ["cur-page", "id-kho", "items", "per-page", "onOnDetailButtonClick", "onRefresh"]),
            (_ctx.phieuNhapKhoItems.length > 0)
              ? (_openBlock(), _createBlock(_component_Pagination, {
                  key: 0,
                  page: _ctx.currentPagePhieuNhap,
                  total: _ctx.totalPhieuNhapItems,
                  onChangePage: _cache[13] || (_cache[13] = (value) => (_ctx.currentPagePhieuNhap = value)),
                  onChangePageSize: _cache[14] || (_cache[14] = (value) => (_ctx.perPagePhieuNhap = value))
                }, null, 8, ["page", "total"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_PageContentSection, null, {
          header: _withCtx(() => [
            _createTextVNode("Phiếu xuất kho")
          ]),
          actions: _withCtx(() => [
            _createVNode(_component_Can, {
              all: [_ctx.PHIEU_XUAT_KHO.TAO_MOI]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_RouterLink, {
                  to: {
              name: 'tao-phieu-xuat-kho-thu-hoi',
              query: {
                idKho: String(_ctx.warehouseId),
              },
            }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ButtonCustom, {
                      "button-type": _ctx.ButtonsType.SOLID_FILE_EXPORT
                    }, {
                      "button-label": _withCtx(() => [
                        _createTextVNode("Xuất vật tư thu hồi")
                      ]),
                      _: 1
                    }, 8, ["button-type"])
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _: 1
            }, 8, ["all"]),
            _createVNode(_component_Can, {
              all: [_ctx.PHIEU_XUAT_KHO.TAO_MOI]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_RouterLink, {
                  to: {
              name: 'tao-phieu-xuat-kho-khac',
              query: {
                idKho: String(_ctx.warehouseId),
              },
            }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ButtonCustom, {
                      "button-type": _ctx.ButtonsType.SOLID_FILE_EXPORT
                    }, {
                      "button-label": _withCtx(() => [
                        _createTextVNode("Xuất khác")
                      ]),
                      _: 1
                    }, 8, ["button-type"])
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _: 1
            }, 8, ["all"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_FilterContainer, null, {
              default: _withCtx(() => [
                _createVNode(_component_FilterItem, { label: "Tìm kiếm phiếu xuất" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.searchTermPhieuXuat,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.searchTermPhieuXuat) = $event)),
                      placeholder: "Tìm theo mã hoặc tên",
                      onInput: _ctx.searchPhieuXuat
                    }, null, 8, ["modelValue", "onInput"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_FilterPhieuNhapXuat, {
                  "loai-phieu": "xuat",
                  onUpdateFilters: _ctx.updateFilterPhieuXuat
                }, null, 8, ["onUpdateFilters"])
              ]),
              _: 1
            }),
            _createVNode(_component_PhieuXuatKhoTable, {
              "cur-page": _ctx.currentPagePhieuXuat,
              items: _ctx.phieuXuatKhoItems,
              "per-page": _ctx.perPagePhieuXuat,
              "show-xuat-tai-kho-column": false,
              onRefresh: _ctx.fetchPhieuXuatItems
            }, null, 8, ["cur-page", "items", "per-page", "onRefresh"]),
            (_ctx.phieuXuatKhoItems.length > 0)
              ? (_openBlock(), _createBlock(_component_Pagination, {
                  key: 0,
                  page: _ctx.currentPagePhieuXuat,
                  total: _ctx.totalPhieuXuatItems,
                  onChangePage: _cache[16] || (_cache[16] = (value) => (_ctx.currentPagePhieuXuat = value)),
                  onChangePageSize: _cache[17] || (_cache[17] = (value) => (_ctx.perPagePhieuXuat = value))
                }, null, 8, ["page", "total"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}